import { createTheme } from "@mui/material/styles"
import baseTheme from "@mobilemind/common/src/theme/theme"

/**
 * MobileMind Data Portal Theme
 * Creates and exports the Material-UI theme configuration
 */
const theme = createTheme(
  {
    palette: {},
    components: {
      MuiStack: {
        defaultProps: {
          useFlexGap: true,
        },
      },
    },
  },
  baseTheme
)

export default theme
